import { gql } from 'graphql-request'

import { GenericBlock } from './generic'

export const imageFragment = gql`
  fragment imageFragment on ImageBlock {
    id
    blockImage: image {
      id
      url
    }
    caption
  }
`

export interface Image extends GenericBlock<'ImageBlock'> {
  blockImage: {
    id: string
    url: string
  }
  caption: string
}
